"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BrowserStorage {
    get storage() {
        return window.localStorage;
    }
    async get(key) {
        return this.storage.getItem(key) || undefined;
    }
    async set(key, value) {
        this.storage.setItem(key, value);
    }
    async delete(key) {
        this.storage.removeItem(key);
    }
}
exports.default = BrowserStorage;
//# sourceMappingURL=BrowserStorage.js.map